import { createAction, props } from '@ngrx/store'
import { PagoInterface } from '@shared/interfaces/app.state.interfaces'

export const pagos = createAction(
    '[pagos] Item',
    props<{ item: PagoInterface }>()

)